import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceAttributesComponent } from './marketplace-attributes.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [MarketplaceAttributesComponent],
  imports: [
    CommonModule,
    PipesModule,
    DirectivesModule,
    FormsModule,
    FGBSharedModule
  ],
  exports: [MarketplaceAttributesComponent],
})
export class MarketplaceAttributesModule {}
